import { ProductType } from "@/core/entities/product";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { TransactionTypes } from "@/stores";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const productRepository = repositoryHost.getProductRepository(databaseService);

export const useGetProducts = () => {
  return useQuery({
    queryKey: ["product", "get"],
    queryFn: async () => {
      const products = await productRepository.getAll({});
      return products
        .filter((product) => !product.inactive)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  });
};

export const useGetLimitedProducts = ({
  limit = 6,
  transactionType,
}: {
  limit: number;
  transactionType: TransactionTypes;
}) => {
  const productsQuery = useGetProducts();

  return {
    ...productsQuery,
    data: productsQuery.data
      ?.filter(
        (product) =>
          product.buyOrSell === ProductType.BOTH ||
          (transactionType === TransactionTypes.BUY &&
            product.buyOrSell === ProductType.BUY) ||
          (transactionType === TransactionTypes.SELL &&
            product.buyOrSell === ProductType.SELL),
      )
      ?.slice(0, limit),
  };
};

export const useGetProductById = (id: string) => {
  return useQuery({
    queryKey: ["product", "id", id],
    queryFn: () => productRepository.get({ id }),
    enabled: !!id,
  });
};
